import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PartnerWalletListState,
  PARTNER_WALLET_LIST_STATE,
} from './partner-wallet-list.state';

export const selectPartnerWallet =
  createFeatureSelector<PartnerWalletListState>(PARTNER_WALLET_LIST_STATE);

export const selectPartnerWalletList = createSelector(
  selectPartnerWallet,
  (state: PartnerWalletListState) => {
    return state.dataSource;
  }
);

export const selectPartnerWalletListFilter = createSelector(
  selectPartnerWallet,
  (state: PartnerWalletListState) => state.filter
);
